import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'
import Main from '../components/pages/main/Main';
import Login from '../components/pages/authentication/Login';
import Register from '../components/pages/authentication/Register';
import Confirm from '../components/pages/authentication/Confirm';
import ResetPassword from '../components/pages/authentication/ResetPassword';
import ChangePassword from '../components/pages/authentication/ChangePassword';
import Error from '../components/pages/errors/Error';
import Application from '../components/pages/application/Application';
import External from '../components/pages/main/External';

Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/main/:applicationName?',
    name: 'Main',
    component: Main
  },
  {
    path: '/application/:applicationName',
    name: "Application",
    component: Application
  },
  {
    path: '/login/:applicationName?',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register/:applicationName?',
    name: 'Register',
    component: Register,
  },
  {
    path: '/confirm/:applicationName/:userName',
    name: 'Confirm',
    component: Confirm,
  },
  {
    path: '/change-password/:applicationName?/:userName',
    name: 'ChangePassword',
    component: ChangePassword,
  },
  {
    path: '/reset-password/:applicationName?',
    name: 'ResetPassword',
    component: ResetPassword,
  },
  {
    path: '/error/:code',
    name: 'Error',
    component: Error
  },
  {
    path: '*',
    redirect: '/error/404'
  },
  {
    path: '/external/:transactionName/:token',
    name: 'External',
    component: External
  }
]

const router = new VueRouter({
  //mode: "history",
  routes
})

export default router
